import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { SampleTagResponse } from '../AddTags/types';
import { ActionsCell } from './columns';
import { formatDate, getTypeColor, getTypeDisplayText } from './utils';
import { SampleTagImage } from '../SampleTagImage/SampleTagImage';

interface UseTransformedRowsProps {
  sampleTagsData?: { tags: SampleTagResponse[] };
  userId: string;
  handleEditClick: (id: string) => void;
  handleDuplicateClick: (id: string) => void;
  handlePrintClick: (id: string) => void;
}

export const useTransformedRows = ({
  sampleTagsData,
  userId,
  handleEditClick,
  handleDuplicateClick,
  handlePrintClick,
}: UseTransformedRowsProps) =>
  useMemo(
    () =>
      (sampleTagsData?.tags || []).map((tag: SampleTagResponse) => ({
        id: tag.id,
        photo: (
          <SampleTagImage
            sampleTag={tag}
            alt={`Sample tag ${
              tag.type_of_sample_tag === 'Block'
                ? tag.block_number
                : tag.style_number
            }`}
            className="w-12 h-12 object-cover rounded"
          />
        ),
        style_number:
          tag.type_of_sample_tag === 'Block'
            ? tag.block_number
            : tag.style_number,
        type_of_sample_tag: {
          color: getTypeColor(tag.type_of_sample_tag),
          contrast: 'low',
          size: 'sm',
          children: getTypeDisplayText(tag.type_of_sample_tag),
        },
        po_number: tag.po_number ? (
          <Link
            to={`/users/${userId}/purchase-orders/${tag.po_number}`}
            className="text-primary-700 font-semibold hover:underline"
          >
            {tag.po_number}
          </Link>
        ) : (
          ''
        ),
        created_at: (
          <span className="text-sm text-gray-600">
            {tag.created_at ? formatDate(tag.created_at) : 'N/A'}
          </span>
        ),
        actions: (
          <ActionsCell
            tagId={tag.id}
            onEdit={handleEditClick}
            onDuplicate={handleDuplicateClick}
            onPrint={handlePrintClick}
          />
        ),
      })),
    [
      sampleTagsData?.tags,
      userId,
      handleEditClick,
      handleDuplicateClick,
      handlePrintClick,
    ],
  );
